import { Button, Grid, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import styles from 'components/Chart/ChartTypeSwitcher/ChartType.module.scss'
import clsx from 'clsx'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const ChartTypeSwitcher = ({ className = '', handleClick = () => {}, chartType }) => {
  const breakpoints = useBreakpoint()

  return !breakpoints.md ? (
    <Button
      noLabel
      variant="ghost"
      grey
      className={clsx(styles['chart-type_active'], className)}
      onClick={handleClick}
      startIcon={
        <Icon
          className={styles['chart-type__icon']}
          name={chartType === 'Line' ? 'bars' : 'line'}
          size={'m'}
        />
      }
    />
  ) : (
    <Grid
      gap={16}
      className={className}
      direction={'row'}
      wrap={false}
    >
      <Button
        variant={'ghost'}
        grey
        link
        noLabel
        color={'Interface-Seventh'}
        className={clsx(styles['chart-type'], {
          [styles['chart-type_active']]: chartType === 'Bar',
        })}
        onClick={handleClick}
        startIcon={
          <Icon
            className={styles['chart-type__icon']}
            name={'bars'}
            size={'m'}
          />
        }
      />
      <Button
        variant="ghost"
        grey
        link
        noLabel
        color={'Interface-Seventh'}
        className={clsx(styles['chart-type'], {
          [styles['chart-type_active']]: chartType !== 'Bar',
        })}
        onClick={handleClick}
        startIcon={
          <Icon
            className={styles['chart-type__icon']}
            name={'line'}
            size={'m'}
          />
        }
      />
    </Grid>
  )
}

export default ChartTypeSwitcher

ChartTypeSwitcher.defaultProps = {
  className: '',
  chartType: 'Line',
}

ChartTypeSwitcher.propTypes = {
  className: PropTypes.string,
  handleClick: PropTypes.func,
  chartType: PropTypes.string,
}
